import React from "react";
import { Routes, Route, HashRouter } from "react-router-dom";
import { RoleProvider } from "./context/RoleContext";
import RequireRole from "./components/RequireRole";


import MainLayout from "./layout/MainLayout";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import CreateRidePage from "./pages/CreateRidePage";
import EditRidePage from "./pages/EditRidePage";
import RidesPage from "./pages/RidesPage";
import DriversPage from "./pages/DriversPage";
import ClientsPage from "./pages/ClientsPage";
import ZonesPage from "./pages/ZonesPage";
import DispatcherPage from "./pages/DispatcherPage";
import AdminSupportPage from "./pages/AdminSupportPage";

function App() {
  return (
    <HashRouter>
      <RoleProvider>
        <Routes>
          {/* LOGIN */}
          <Route path="/login" element={<LoginPage />} />

          {/* ZONE PROTÉGÉE */}
          <Route path="/" element={<MainLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="rides" element={<RidesPage />} />
            <Route path="rides/create" element={<CreateRidePage />} />
            <Route path="rides/:id/edit" element={<EditRidePage />} />
            <Route path="drivers" element={<DriversPage />} />
            <Route path="clients" element={<ClientsPage />} />
            <Route path="zones" element={ <RequireRole allowedRoles={["admin"]}> <ZonesPage /> </RequireRole>} />
            <Route path="dispatchers" element={ <RequireRole allowedRoles={["admin"]}><DispatcherPage /></RequireRole>} />
            <Route path="support" element={<AdminSupportPage />} />
          </Route>
        </Routes>
      </RoleProvider>
    </HashRouter>
  );
}

export default App;



